<template>
  <div data-component="bigHeading">
    <div class="heading">
      <span data-ornament="rectangle" />
      <markdown class="markdown">## {{data.heading}}</markdown>
      <span class="byline" v-if="data.byline">{{data.byline}}</span>
    </div>
  </div>
</template>

<script>
// Module expects:
// - heading
// - byline (optional)
export default {
  name: 'component_bigHeading',
  props: ['data'],
};
</script>

<style lang="scss">
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';
@import '~@/styles/_typography.scss';

[data-component="bigHeading"] {

    /* markdown overrides */
  .markdown {
    h2 {
      // media query props
      @include serif( $size: (35, 35, 0), $weight: 'bold');
      margin-bottom: rem(12px);

      @include ngMq($nbp--tablet, up) {
        @include serif( $size: (50, 50, 0), $weight: 'bold');
      }
      @include ngMq($nbp--desktop, up) {
        @include serif( $size: (72, 70, 0), $weight: 'bold');
      }
    }
  }

  [data-ornament="rectangle"] {
    display: block;
    width: rem(80px);
    margin-bottom: rem(15px);
    @include createOrnament($type: rectangle);

    @include ngMq($nbp--tablet, up) {
      position: absolute;
      bottom: 100%;
      left: 0;
      margin-bottom: rem(30px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bigHeading.vue